/**
 * @file IconTipWrong Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-tip-wrong',
  (data) => `
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg
  width="${data.size}"
  height="${data.size}"
  class="icon"
  p-id="8375"
  t="1681968311046"
  viewBox="0 0 1024 1024"
>
  <path
    fill="${data.colorDesc[0]}"
    d="M512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512zM339.2 268.8c-19.2-19.2-44.8-19.2-64 0-19.2 19.2-19.2 44.8 0 64L448 512l-172.8 172.8c-19.2 19.2-19.2 44.8 0 64 19.2 19.2 44.8 19.2 64 0L512 576l172.8 172.8c19.2 19.2 44.8 19.2 64 0 19.2-19.2 19.2-44.8 0-64L576 512l172.8-172.8c19.2-19.2 19.2-44.8 0-64-19.2-19.2-44.8-19.2-64 0L512 448 339.2 268.8z"
    p-id="8376"
  />
</svg>
`
);
